/**
 * MUI TextField and React's onWheel use passive listeners, so preventDefault
 * does not block browser stepping on <input type="number">. Attach a non-passive
 * wheel listener on the real input element instead.
 *
 * @param {React.MutableRefObject|function} [mergeRef] - optional ref to forward to
 * @returns {function} - pass to TextField as inputRef
 */
export function numberInputNoWheelRef(mergeRef) {
  let node = null;
  let handler = null;

  return function inputRef(inputEl) {
    if (node) {
      node.removeEventListener("wheel", handler);
      node = null;
      handler = null;
    }
    if (mergeRef) {
      if (typeof mergeRef === "function") mergeRef(inputEl);
      else mergeRef.current = inputEl;
    }
    if (inputEl) {
      handler = (e) => e.preventDefault();
      inputEl.addEventListener("wheel", handler, { passive: false });
      node = inputEl;
    }
  };
}

/**
 * Stable inputRef for lists keyed by id (criteria rows, etc.).
 * @param {Map} cache - instance field, e.g. this._numberWheelRefsById
 * @param {string|number} id
 * @param {React.MutableRefObject|function} [mergeRef]
 */
export function numberInputNoWheelRefForId(cache, id, mergeRef) {
  const key = String(id);
  if (!cache.has(key)) {
    cache.set(key, numberInputNoWheelRef(mergeRef));
  }
  return cache.get(key);
}
